export default __webpack_public_path__ + "static/sponsors-3e48117b5075267239717783bb403bfa.png";